import React from "react";
import { ImageScrollTextData } from "./types";
import { useMediaQuery } from "./hooks/useMediaQuery";
import DesktopImageScrollText from "./DesktopImageScrollText";
import MobileImageScrollText from "./MobileImageScrollText";

interface ImageScrollTextProps {
  data: ImageScrollTextData;
}

export default function ImageScrollText({ data }: ImageScrollTextProps) {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const sectionId = data.sectionName.replace(/\s+/g, "-");

  return (
    <section
      id={sectionId?.replaceAll(/[^a-zA-Z0-9-_]/g, "-")}
      data-name={data.sectionName}
    >
      {isDesktop ? (
        <DesktopImageScrollText data={data} />
      ) : (
        <MobileImageScrollText data={data} />
      )}
    </section>
  );
}
